'use strict';

export default {
  /**
   * The gateway to use
   */
  gateway: "sagepay",

  gatewayId: null,

  type: null,

  step: 1,

  forcedStep: null,

  /**
   * Gets the provider from the API
   */
  getProvider() {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        url: "/api/checkout/provider",
        headers: {
          Accept: "application/json"
        }
      })
        .then(response => {
          resolve(response);
        })
        .catch(errors => {
          reject(errors.response.data);
        });
    });
  },

  setType(type) {
    this.type = type;
    return this;
  },

  /**
   * Process the payment
   * @param {string} token The credit card token
   * @param {string} merchantToken The merchant token
   * @param {string} reference The customer order reference
   * @param {string} notes The order notes
   */
  process(token, merchantToken, reference, notes, type, save, reusable) {

    let data = {
      reference: reference,
      notes: notes,
      type: this.type,
      data: {}
    };

    if (token) {
      data.payment_token = token;
    }

    if (save) {
      data.data.save = true;
    }

    if (reusable) {
      data.data.reusable = true;
    }

    if (merchantToken) {
      data.data.merchant_key = merchantToken;
    }

    if (this.gatewayId) {
      data.gateway_id = this.gatewayId;
    }

    if (type) {
      data.payment_type = type;
    }


    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/api/checkout",
        headers: {
          Accept: "application/json"
        },
        data: data
      })
        .then(response => {
          resolve(response);
        })
        .catch(errors => {
          reject(errors.response.data);
        });
    });
  },

  processThreeD(orderId, transactionId, payload) {

    payload.order_id = orderId;
    payload.transaction = transactionId;

    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/api/checkout/3d-secure",
        headers: {
          Accept: "application/json"
        },
        data: payload
      })
        .then(response => {
          resolve(response);
        })
        .catch(errors => {
          reject(errors.response.data);
        });
    });
  },

  /**
   * Sets the driver for the payment gateway
   * @param {string} gateway
   */
  setGateway(gateway) {
    this.gateway = gateway;
    return this;
  },

  /**
   * Set the gateway id
   */
  setGatewayId(id) {
    this.gatewayId = id;
    return this;
  },

  /**
   * Get the gateways from the API
   */
  getGateways() {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        url: "/api/checkout/gateways",
        headers: {
          Accept: "application/json"
        }
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(errors => {
          reject(errors.response.data);
        });
    });
  },

  /**
   * Sets the current checkout step
   * @param {number} step
   */
  setStep(step, goback) {
    if (step <= this.step && !goback) {
      return this;
    }
    this.step = step;

    return this;
  },

  forceStep(step) {
    if (step) {
      this.step = step;
      this.forcedStep = step;
    } else {
      this.forcedStep = null;
    }
    return this;
  },

  /**
   * Go to the next step
   */
  next() {
    if (!this.forcedStep) {
      this.step += 1;
    }
    return this;
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/Services/Checkout.js